import RadioFieldComponent from './radio-field-component';

/***
 * A field that renders a row of radio button options. It expects to be passed a lost of options, with each option being
 * an object containing a "label" and a "value" parameter.
 */
const radioField = angular
    .module('FacilityData.ClientEdit.FormFields.RadioField', [])
    .component('radioField', RadioFieldComponent)
    .name;

export default radioField;


// WEBPACK FOOTER //
// ./app/common/form-fields/radio-field/radio-field.js